import PageShell from "@/components/layout/PageShell";
import PageCTA from "@/components/sections/PageCTA";
import Process from "@/components/sections/Process";

const details = [
  {
    n: "01",
    title: "Discover",
    body:
      "Every APEX engagement starts with structured discovery. We interview stakeholders, audit your current website and analytics, review the competitive landscape, and interview a small sample of customers. The output is a written positioning + audience document that everything else is built from.",
  },
  {
    n: "02",
    title: "Plan",
    body:
      "We turn discovery into a concrete plan: a sitemap, a content plan, target SEO and AEO keywords, wireframe direction, KPIs to move, and a delivery calendar. You sign off before we design.",
  },
  {
    n: "03",
    title: "Design & Build",
    body:
      "Design and development happen in tandem, with weekly review checkpoints. We design in high-fidelity, write conversion-focused copy, and ship on a modern, fast, SEO-safe stack.",
  },
  {
    n: "04",
    title: "Launch",
    body:
      "A proper launch checklist: SEO-safe migration, 301 redirects, XML sitemap, structured data, analytics + Search Console, page-speed pass, accessibility check, and a soft rollout with monitoring.",
  },
  {
    n: "05",
    title: "Optimize",
    body:
      "Post-launch is where compounding gains happen. We publish content, run monthly experiments on landing pages and funnels, and report on the KPIs we agreed at plan stage.",
  },
];

export default function ProcessPage() {
  return (
    <PageShell
      testId="process-page"
      eyebrow="Our process"
      title={<>How APEX takes projects from <span className="text-apex-orange">idea to compounding growth.</span></>}
      subtitle="A calm, transparent 5-step process. One project lead, weekly syncs, a shared roadmap, and reporting you actually understand."
      breadcrumbs={[{ label: "Process" }]}
      seoTitle="Our Process | 5-Step Web Design & SEO Delivery — APEX Innovation Solutions"
      seoDescription="Discover the APEX 5-step process: Discover, Plan, Design, Launch, Optimize. Transparent, structured, and built for measurable business growth."
    >
      <Process />

      <section className="section-pad relative">
        <div className="container-apex">
          <div className="max-w-3xl">
            <div className="eyebrow mb-4"><span className="w-6 h-px bg-apex-cyan" /> Deep dive</div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-[1.05]">
              What actually happens at <span className="text-apex-orange">each step.</span>
            </h2>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
            {details.map((d) => (
              <div key={d.n} className="glass glass-hover p-6" data-testid={`process-detail-${d.n}`}>
                <div className="flex items-baseline gap-3">
                  <span className="stroke-num text-3xl font-heading">{d.n}</span>
                  <h3 className="font-heading font-bold text-xl">{d.title}</h3>
                </div>
                <p className="mt-3 text-sm text-white/75 leading-relaxed" data-align-preserve>{d.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PageCTA
        title="Ready to start the discovery step?"
        subtitle="Book a free intro call — we'll show you the discovery deliverable from a recent project."
        primary={{ label: "Book Discovery Call", to: "/contact" }}
        secondary={{ label: "View Services", to: "/services" }}
      />
    </PageShell>
  );
}
